import type { NodeRecord } from '@ipfabric/utils';
import { record } from 'fp-ts';
import { pipe } from 'fp-ts/lib/pipeable';
import { createSelector } from 'reselect';
import { createScopedSelector } from 'utils/react/scopedSelector';
import type { GraphState } from '../../GraphState';

export const selectNotHiddenNodes: (s: GraphState) => NodeRecord =
  createScopedSelector(() =>
    createSelector(
      (s) => s.graph.nodes,
      (s) => s.graph.hiddenNodes,
      (nodes, hiddenNodes) =>
        pipe(
          nodes,
          record.filter((nodeData) => !hiddenNodes.has(nodeData.id)),
        ),
    ),
  );
